exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3ab0nxBeK0FBxnHHbfUmdP{display:flex;flex-direction:column;margin-bottom:40px}\n", ""]);

// Exports
exports.locals = {
	"times": "_3ab0nxBeK0FBxnHHbfUmdP"
};